export default __webpack_public_path__ + "static/jones-20dcb44aa8e6a1abb2214685492ef723.jpg";